import { TierChangePolicy } from "@mimber/schema"

export const TIER_CHANGE_POLICY_OPTIONS = [
  {
    label: "Next Cycle",
    value: TierChangePolicy.NEXT_CYCLE,
  },
  {
    label: "Prorate",
    value: TierChangePolicy.PRORATE,
  },
  {
    label: "Void & Restart Immediately",
    value: TierChangePolicy.IMMEDIATE,
  },
]

export const TIER_CHANGE_POLICY_HELP_TEXT =
  "Next Cycle: the old invoice stays as-is and the new tier's price applies starting the next renewal. " +
  "Prorate: a partial invoice for the price difference is generated now, due immediately, and the next renewal bills the new tier's full price. " +
  "Void & Restart Immediately: any open invoice for the old tier is voided and a full-price invoice for the new tier is generated now, starting a fresh billing cycle."
